import { Injectable } from '@angular/core';
import { App } from '@df/core/app';
import { RequestService } from '@df/api/request/request.service';

/**
 * AudioEye accessibility service
 * Loads AudioEye script for accessibility features
 */
@Injectable({ providedIn: 'root' })
export class AudioEyeService {
    private readonly AUDIOEYE_SITE_HASH = '29e5e44f52182b5a4a48b9144104f2c7';
    private readonly AUDIOEYE_SCRIPT_URL = 'https://wsmcdn.audioeye.com/aem.js';

    constructor(
        private app: App,
        private requestService: RequestService
    ) {
        this.load();
    }

    /**
     * Initialize AudioEye service
     * Sets the site hash and loads the AudioEye script
     */
    protected load(): void {
        if (!this.app.isPlatformBrowser) {
            return;
        }

        window.__AudioEyeSiteHash = this.AUDIOEYE_SITE_HASH;
        this.requestService.loadScriptAsync(this.AUDIOEYE_SCRIPT_URL);
    }
}

/**
 * Extend Window interface with AudioEye properties
 */
declare global {
    interface Window {
        __AudioEyeSiteHash?: string;
    }
}

